/**
 * Enables mocking for API requests if the environment mode is set to "mock".
 * This function dynamically imports and starts the Mock Service Worker (MSW)
 * to intercept and handle API requests for testing purposes.
 *
 * @returns A Promise that resolves to the ServiceWorkerRegistration object if mocking is enabled,
 *          or undefined if mocking is not enabled.
 */
export async function enableMocking(): Promise<
  ServiceWorkerRegistration | undefined
> {
  // Check if the environment mode is set to "mock"
  if (import.meta.env.MODE !== "mock") {
    // If not in "mock" mode, return undefined and do not enable mocking
    return;
  }

  // Dynamically import the MSW setup worker module
  const { worker } = await import("@/mocks/setupWorker");

  // Start the Mock Service Worker and return the ServiceWorkerRegistration object
  return worker.start();
}
